import security from "../libs/security";

function useStorage() {
  const setItem = (key, value, type) => {
    if (typeof window !== "undefined") {
      try {
        const encryptedData = security.encryptData(value);
        const encryptedKey = security.encodeData(key);
        if (type === "session") {
          sessionStorage.setItem(encryptedKey, encryptedData);
        } else {
          localStorage.setItem(encryptedKey, encryptedData);
        }
      } catch (error) {
        console.error("Gagal menyimpan item", error);
      }
    }
  };

  const getItem = (key, type) => {
    if (typeof window !== "undefined") {
      try {
        let encryptedData;
        const encryptedKey = security.encodeData(key);
        if (type === "session") {
          encryptedData = sessionStorage.getItem(encryptedKey);
        } else {
          encryptedData = localStorage.getItem(encryptedKey);
        }
        return encryptedData ? security.decryptData(encryptedData) : null;
      } catch (error) {
        console.error("Gagal mengambil item", error);
        return null;
      }
    }
    return null;
  };

  const removeItem = (key, type) => {
    if (typeof window !== "undefined") {
      try {
        const encryptedKey = security.encodeData(key);
        if (type === "session") {
          sessionStorage.removeItem(encryptedKey);
        } else {
          localStorage.removeItem(encryptedKey);
        }
      } catch (error) {
        console.error("Gagal menghapus item", error);
      }
    }
  };

  const clear = () => {
    if (typeof window !== "undefined") {
      try {
        sessionStorage.clear();
        localStorage.clear();
      } catch (error) {
        console.error("Gagal menghapus semua item", error);
      }
    }
  };

  return { setItem, getItem, removeItem, clear };
}

export default useStorage;
